import { CloudArrowUp, CloudCheck, CloudSlash } from '../design-system/icons';
import { useDraftStatus, type DraftStatus } from './draftStatus';
import { TOP_BAR_PILL_CLASS } from '../components/common/topBarPill';

const LABEL: Record<DraftStatus, string> = {
  idle: 'Drafts save automatically',
  saving: 'Saving…',
  saved: 'Draft saved',
  error: "Couldn't save draft",
};

export function DraftStatusBadge() {
  const status = useDraftStatus();
  const failed = status === 'error';
  return (
    <span className={TOP_BAR_PILL_CLASS}>
      {failed ? (
        <CloudSlash size={15} className="text-destructive" aria-hidden="true" />
      ) : status === 'saving' ? (
        <CloudArrowUp size={15} className="text-muted-foreground" aria-hidden="true" />
      ) : (
        <CloudCheck size={15} className="text-muted-foreground" aria-hidden="true" />
      )}{' '}
      {/* Below sm the label drops to icon-only (still read by screen readers) so the right
          side doesn't push the breadcrumb out at 390px. */}
      <span className="max-sm:sr-only" aria-hidden={failed || undefined}>
        {LABEL[status]}
      </span>
      {/* Only a failure is announced: "Saving…" and "Draft saved" would fire at
          every typing pause. Always mounted so the text change is reliably read. */}
      <span role="alert" className="sr-only">
        {failed ? LABEL.error : ''}
      </span>
    </span>
  );
}
